﻿import * as React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";

export interface IApplication {
    applicationID: number;
    groupID: number;
    applicationName: string;
    brandedName: string;
    publishDate: string;
    version: string;
    readLatest: boolean;
}

interface IApplicationsProps {
    applications: IApplication[];
    selectedGroup: number;
    selectedApplication: number;
    handleApplicationClick: (groupID) => void;
}

export const Applications: React.FunctionComponent<IApplicationsProps> = (
    props,
): React.ReactElement => {
    let applicationList;

    const filteredApplications = props.applications.filter(
        (n) => n.groupID === props.selectedGroup,
    );

    if (props.applications != null) {
        applicationList = filteredApplications.map((application) => {
            if (application.groupID === props.selectedGroup) {
                return (
                    <div key={application.applicationID}>
                        <ListItem
                            button={true}
                            className={`releasenotes-listitem`}
                            disableRipple={true}
                            key={application.applicationID}
                            onClick={(): void =>
                                props.handleApplicationClick(
                                    application.applicationID,
                                )
                            }
                            selected={
                                props.selectedApplication ===
                                application.applicationID
                            }
                        >
                            <ListItemText
                                disableTypography={true}
                                primary={
                                    application.readLatest ? (
                                        <div
                                            className={`releasenotes-list-primary`}
                                        >
                                            {application.brandedName}
                                        </div>
                                    ) : (
                                        <div
                                            className={`releasenotes-list-primary`}
                                        >
                                            <span>
                                                {application.brandedName}
                                            </span>
                                            <span
                                                className={`releasenotes-readlatest`}
                                            />
                                        </div>
                                    )
                                }
                                secondary={
                                    <div
                                        className={`releasenotes-list-secondary`}
                                    >
                                        <div>{`Last updated: ${application.publishDate.substr(
                                            0,
                                            10,
                                        )}`}</div>
                                        <div>{`V${application.version}`}</div>
                                    </div>
                                }
                            />
                        </ListItem>
                        <div className={`releasenotes-linebreak`} />
                    </div>
                );
            } else {
                return null;
            }
        });
    } else {
        applicationList = (
            <ListItem>
                <ListItemText primary={`Loading`} secondary={``} />
            </ListItem>
        );
    }

    // Remove null elements
    const filteredList = applicationList.filter((n) => n);

    return <List className={`releasenotes-scrollable`}>{filteredList}</List>;
};
